var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.request.isDone ? _c('v-dialog', {
    attrs: {
      "width": _vm.width,
      "max-width": _vm.maxWidth
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "outlined": "",
            "color": "gray-9"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("자문보고서")])];
      }
    }], null, false, 3324225775),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('counsel-report-card', {
    attrs: {
      "request": _vm.request
    }
  }), _c('v-btn', {
    attrs: {
      "fixed": "",
      "right": "",
      "bottom": "",
      "fab": "",
      "elevation": "24",
      "id": "print-button"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', [_vm._v("mdi-printer")])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }